const globals = {
    api_url: "https://uploads.peerxc.com",
    api_root: 'https://uploads.peerxc.com',
    upload_root: 'https://uploads.peerxc.com'
}
export default globals